<template>
  <div class="_main-container kaimashi" id="jumpTo">
    <div class="mainContentBox">
      <div class="mainContentBoxInner" v-if="status == 'edit'">
        <div class="pageTitleWrapper">
          <h2 class="pageTitle">買い替え・買い増し特典</h2>
        </div>
        <!--
        <div class="pageCaption"> お友達やお知り合いにJR東日本伊藤忠不動産開発の新築分譲マンション「クレヴィア」をご紹介ください。<br>マンションの情報はトップページにございます「伊藤忠の住まい」よりご確認お願いいたします。<span class="pageCaption-caution">※所有者様限定のサービスとなっております。</span></div>
        -->
        <div class="mvBox">
          <img
            src="/i-salon/assets/img/kaimashi/fig01.jpg"
            alt="買い替え・買い増し特典"
          />
        </div>
        <!--
        <div class="stepBox">
          <ul>
            <li>
              <img src="/i-salon/assets/img/friend/step1.png" alt="STEP1" />
            </li>
            <li>
              <img src="/i-salon/assets/img/friend/step2.png" alt="STEP2" />
            </li>
            <li>
              <img src="/i-salon/assets/img/friend/step3.png" alt="STEP3" />
            </li>
          </ul>
        </div>
        -->

        <div class="cautionBox" style="padding-bottom: 4rem;">
          <ul class="caution" style="background:#f8f8fe;padding:1.5rem;color: #6f6f72;line-height: 2rem;font-size: 1.2rem;">
            <li>※購入代金（税込価格）の1.0%が割引となります。</li>
            <li>※現在販売中の新築物件「クレヴィア」シリーズが割引対象となります。</li>
            <li>※過去に伊藤忠グループが分譲した「クレヴィア」「イトーピア」「シーアイ」シリーズの物件を所有されているお客様が対象となり、割引対象物件の購入申込時において、所有が確認できる書類を提出頂きます。（例：登記簿謄本等）</li>
            <li>※現所有物件と同一名義での買い替え・買い増しのみ割引適用となります。</li>
            <li>※初回来場時に、ISALONにて掲示している本特典利用の旨を販売員までお伝えください。</li>
            <li>※他の割引・サービスとの併用はできません。</li>
            <li>※本特典は予告なく終了、または内容を変更する場合があります。</li>
            <li>※本特典に関するお問い合わせは、I’SALON上の問い合わせフォームまたは販売員へお問い合わせください。</li>
          </ul>
        </div>

        <div style="
            border-top: 2px solid #f1ab71;
            font-size: 130%;
            padding: 16px 10px;
            border-bottom: 2px solid #f1ab71;
            margin-bottom: 3em;
            ">
            <span style="
            font-weight: bold;
            display: block;
            margin-bottom: 16px;
            color: #ec992a;
            font-size: 110%;
            ">販売ギャラリー問合せ先</span>
        
        <span style="
            font-weight: bold;
            display: block;
            margin-bottom: 16px;
            ">・ギャラリークレヴィア有楽町イトシア<br>
            　TEL：0120-852-878</span>
        
        <span style="
            font-weight: bold;
            display: block;
            margin-bottom: 16px;
            ">・ギャラリークレヴィア 新宿<br>
            　TEL：0120-300-631</span>
        
        <span style="
            font-weight: bold;
            display: block;
            margin-bottom: 16px;
            ">・ギャラリークレヴィア横浜 スカイビル<br>
            　TEL：0120-00-4580</span>
        
        <span>［平日］11：00～19：00<br>
        ［土日祝］10：00～18：00<br>
        ［定休日］水・木曜日・第2火曜日（祝日を除く）</span>

        <span style="
          display: block;
          margin: 6px 0 0 0.6em;
          ">※西日本エリアの販売物件についても、上記からお問合せが可能です。</span>

        </div>
        
        <section class="block" style="padding-bottom:1rem;">
          <h2 class="blocktitle">お客様情報</h2>
          <span class="itemText" style="display: block;padding:1rem 0;font-size: 1.3rem;">お客様の情報を入力してください。</span>
        </section>

        <section class="mainContent-form">
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="L_NAME">お名前</label>
            </dt>
            <dd class="formTable_data">
              <dl class="formTableBox">
                <dt class="formTableBox_ttl"><label for="L_NAME">姓</label></dt>
                <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                  <input
                    type="text"
                    id="L_NAME"
                    maxlength="40"
                    class="m-formBox_input--name u-ime-ja"
                    placeholder="例:伊藤"
                    name="lastName"
                    v-model.trim="$v.values.sei.$model"
                  />
                  <div class="error" v-if="!$v.values.sei.required">
                    必須です
                  </div>
                </dd>
                <dt class="formTableBox_ttl"><label for="F_NAME">名</label></dt>
                <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                  <input
                    type="text"
                    id="F_NAME"
                    maxlength="40"
                    class="formTableBox_input--name u-ime-ja"
                    placeholder="例:忠太郎"
                    name="firstName"
                    v-model.trim="$v.values.mei.$model"
                  />
                  <div class="error" v-if="!$v.values.mei.required">
                    必須です
                  </div>
                </dd>
              </dl>
              <span class="formErr_inline"> </span>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="L_NAME">ふりがな</label>
            </dt>
            <dd class="formTable_data">
              <dl class="formTableBox">
                <dt class="formTableBox_ttl">
                  <label for="L_NAME">せい</label>
                </dt>
                <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                  <input
                    type="text"
                    id="L_NAME"
                    maxlength="40"
                    class="m-formBox_input--name u-ime-ja"
                    placeholder="例:いとう"
                    name="lastName"
                    v-model.trim="$v.values.kanaSei.$model"
                  />
                  <div class="error" v-if="!$v.values.kanaSei.required">
                    必須です
                  </div>
                </dd>
                <dt class="formTableBox_ttl">
                  <label for="F_NAME">めい</label>
                </dt>
                <dd class="formTableBox_itemBox formTableBox_itemBox_name">
                  <input
                    type="text"
                    id="F_NAME"
                    maxlength="40"
                    class="formTableBox_input--name u-ime-ja"
                    placeholder="例:ちゅうたろう"
                    name="firstName"
                    v-model.trim="$v.values.kanaMei.$model"
                  />
                  <div class="error" v-if="!$v.values.kanaMei.required">
                    必須です
                  </div>
                </dd>
              </dl>
              <span class="formErr_inline"> </span>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">購入希望物件</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id=""
                    ><input
                      type="text"
                      id=""
                      class="u-input--w100p u-ime-ja"
                      maxlength="512"
                      name=""
                      v-model.trim="$v.values.bukken.$model"
                  /></label>
                  <div class="error" v-if="!$v.values.bukken.required">
                    必須です
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <!--
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">マンション名</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id="">{{ mansionName }}</label>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">部屋番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id="">{{ currentUser.roomNo }}</label>
                </div>
              </div>
            </dd>
          </dl>
          -->
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">所有されているクレヴィア・イトーピア・シーアイ物件名、部屋番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id=""
                    ><input
                      type="text"
                      id=""
                      class="u-input--w100p u-ime-ja"
                      maxlength="512"
                      name=""
                      placeholder="クレヴィア伊藤忠　100号室"
                      v-model.trim="$v.values.ownedBukken.$model"
                  /></label>
                  <div class="error" v-if="!$v.values.ownedBukken.required">
                    必須です
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">現住所</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id=""
                    ><input
                      type="text"
                      id=""
                      class="u-input--w100p u-ime-ja addressInput"
                      maxlength="512"
                      name=""
                      :disabled="values.addressSame"
                      v-model.trim="$v.values.address.$model"
                  /></label>
                  <div class="error" v-if="!$v.values.address.required">
                    必須です
                  </div>
                </div>
                <div class="formTableBox_itemBox" style="margin-top: 8px;">
                  <label>
                    <input
                      type="checkbox"
                      v-model="values.addressSame"
                      :disabled="!values.ownedBukken"
                      @change="onAddressSameChange"
                    />
                    同上（所有物件と同じ住所）
                  </label>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">メールアドレス</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id="">{{ values.email }}</label>
                  <div class="error" v-if="!$v.values.email.required">
                    必須です
                  </div>
                  <div class="error" v-if="!$v.values.email.email">
                    Emailアドレスを入力してください
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">電話番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label id=""
                    ><input
                      type="text"
                      id=""
                      class="u-input--w100p u-ime-en"
                      maxlength="128"
                      name=""
                      v-model.trim="$v.values.phone.$model"
                  /></label>
                  <div class="formTableCautionInner">
                    ※ハイフン（-）なしで数字のみご入力ください。
                  </div>
                  <div class="error" v-if="!$v.values.phone.required">
                    必須です
                  </div>
                  <div class="error" v-if="!$v.values.phone.decimal">
                    半角数字を入力してください
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">ご相談種別</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label v-for="(item, index) in category_options" :key="index">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      :value="item"
                      v-model="$v.values.category.$model"
                    />
                    {{ item }}
                  </label>
                  <div class="error" v-if="!$v.values.category.required">
                    必須です
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label for="">無料査定</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <div style="margin-bottom: 8px;">
                    <input
                      type="radio"
                      id="satei_yes"
                      name=""
                      value="希望します"
                      v-model.trim="$v.values.satei.$model"
                    />
                    <label for="satei_yes">希望します</label>
                  </div>
                  <div style="margin-bottom: 8px;">
                    <input
                      type="radio"
                      id="satei_no"
                      name=""
                      value="希望しません"
                      v-model.trim="$v.values.satei.$model"
                    />
                    <label for="satei_no">希望しません</label>
                  </div>
                  <div class="error" v-if="!$v.values.satei.required">
                    必須です
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">ご相談内容</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <textarea
                    rows="8"
                    class="u-input--w100p u-ime-ja"
                    v-model.trim="$v.values.text.$model"
                  ></textarea>

                  <div class="error">
                    任意です
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <div class="cn-back-btn">
            <a href="javascript:void(0);" @click="onConfirm">次へ</a>
          </div>
        </section>
      </div>

      <div class="mainContentBoxInner" v-else-if="status == 'confirm'">
        <div class="pageTitleWrapper">
          <h2 class="pageTitle">買い替え・買い増し特典</h2>
        </div>

        <div class="pageCaption">
          <div class="contactCaptionDetail">
            入力内容をご確認ください。<br />
            よろしければ「送信」ボタンをクリックしてください。
          </div>
        </div>

        <section class="mainContent-form">
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="L_NAME">名前</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ values.sei }} {{ values.mei }}
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="L_NAME">ふりがな</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ values.kanaSei }} {{ values.kanaMei }}
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label>購入希望物件</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ values.bukken }}
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label>所有されているクレヴィア・イトーピア・シーアイ物件名、部屋番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ values.ownedBukken }}
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label>現住所</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ values.addressSame ? "同上（所有物件と同じ住所）" : values.address }}
                </div>
              </div>
            </dd>
          </dl>
          <!--
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label>マンション名</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ mansionName }}
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label>部屋番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  {{ currentUser.roomNo }}
                </div>
              </div>
            </dd>
          </dl>
          -->

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">メールアドレス</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">{{ values.email }}</div>
              </div>
            </dd>
          </dl>
          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">電話番号</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">{{ values.phone }}</div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">ご相談種別</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <div v-for="(item, index) in values.category" :key="index">
                    {{ item }}
                  </div>
                </div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">無料査定</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">{{ values.satei }}</div>
              </div>
            </dd>
          </dl>

          <dl class="formTable">
            <dt class="formTable_ttl">
              <label for="">ご相談内容</label>
            </dt>
            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <pre>{{ values.text }}</pre>
                </div>
              </div>
            </dd>
          </dl>

          <div class="cn-back-btn">
            <a href="javascript:void(0);" @click="status = 'edit'">戻る</a>
          </div>
          <div class="cn-back-btn">
            <a href="javascript:void(0);" @click="onPost">送信</a>
          </div>
        </section>
      </div>

      <div class="mainContentBoxInner" v-else-if="status == 'complete'">
        <div class="pageTitleWrapper">
          <h2 class="pageTitle">買い替え・買い増し特典</h2>
        </div>

        <div class="pageCaption">
          <div class="contactCaptionDetail">ご相談内容を受け付けました。</div>
        </div>

        <section class="mainContent-form">
          <div class="cn-back-btn">
            <router-link
              :to="{
                name: 'top',
                params: { mc_code: mcCode },
              }"
              >トップページへ</router-link
            >
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, decimal, requiredIf } from "vuelidate/lib/validators";
import OrderService from "../../services/order.service";
import OrderSchemaService from "../../services/order_schema.service";
import store from "../../store";
export default {
  name: "kaimashi",
  data() {
    return {
      status: "edit",
      values: {
        bukken: "",
        ownedBukken: "",
        address: "",
        addressSame: false,
        sei: "",
        mei: "",
        kanaSei: "",
        kanaMei: "",
        email: "",
        phone: "",
        category: [],
        satei: "",
        text: "",
      },
      schema: null,
      // TODO: No.23-24対応(モック) 管理画面のスキーマ更新後、下のmounted()での上書きを元に戻すこと
      category_options: ["買い替えを検討している", "買い増しを検討している", "その他"],
    };
  },
  validations: {
    values: {
      bukken: { required },
      ownedBukken: { required },
      address: {
        required: requiredIf(function() {
          return !this.values.addressSame;
        }),
      },
      sei: { required },
      mei: { required },
      kanaSei: { required },
      kanaMei: { required },
      email: { required, email },
      phone: { required, decimal },
      category: { required },
      satei: { required },
      text: {},
    },
  },
  mounted: async function() {
    console.log("+++ kaimashi.mounted");
    await this.$nextTick();
    const user = store.state.auth.user;
    console.log(user);
    const result = await OrderSchemaService.find({
      mansion: user.mansion.id,
      directory: "kaimashi",
    });
    console.log("result", result);
    this.schema = result.data[0].schema;
    const category = this.schema.find(item => item.name == "category");
    console.log(category);
    // TODO: No.23-24対応(モック) 管理画面のスキーマ更新まで実データでの上書きを止めている
    // this.category_options = category.options;
    console.log(this.category_options);
    this.values.email = user.email;
    if (this.mansion) {
      this.values.ownedBukken = `${this.mansion.name}　${user.roomNo}号室`;
    }
  },
  computed: {
    mansionName() {
      return this.mansion != null ? this.mansion.name : "";
    },
  },
  watch: {
    "values.ownedBukken"(value) {
      if (!value && this.values.addressSame) {
        this.values.addressSame = false;
      } else if (this.values.addressSame) {
        this.values.address = value;
      }
    },
  },
  methods: {
    onAddressSameChange() {
      if (this.values.addressSame) {
        this.values.address = this.values.ownedBukken;
      } else {
        this.values.address = "";
      }
    },
    scrollTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onConfirm() {
      console.log("onConfirm");
      console.log(this.values);
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        this.status = "confirm";
        this.scrollTop();
      }
    },
    async onPost() {
      console.log("onPost");
      console.log(this.values);
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        const result = await OrderService.editByDirectroy(
          "kaimashi",
          this.values,
        );
        this.status = "complete";
        this.scrollTop();
        console.log(result);
      }
    },
  },
};
</script>

<style>
.flex-wrapper {
  display: flex;
}
</style>

<style scoped>
.addressInput:disabled {
  background-color: #eee;
  color: #999;
  cursor: not-allowed;
}
</style>
